import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, MenuItem, Grid, ToggleButton, ToggleButtonGroup
} from '@mui/material';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftInput from 'components/SoftInput';
import { CustomSelect } from '../../components/atoms';
import SoftButton from 'components/SoftButton';
import { Padding } from '@mui/icons-material';

const recurrenceUnits = [{ name: 'DAY' }, { name: 'WEEKLY' }];
const weekDays = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']
  ;

const CustomRecurrenceModal = ({ open, onClose, onSave, repeatEvery, setRepeatEvery, unit, setUnit, selectedDays, setSelectedDays }) => {

  const [errors, setErrors] = useState({
    repeatEvery: '',
    unit: '',
    selectedDays: ''
  });

  const handleDayToggle = (event, newDays) => {
    setSelectedDays(newDays);
  };

  const handleSave = () => {
    let valid = true;
    const newErrors = {
      repeatEvery: '',
      unit: '',
      selectedDays: ''
    };

    if (!repeatEvery || repeatEvery < 1) {
      newErrors.repeatEvery = 'Repeat value must be at least 1';
      valid = false;
    }

    if (!unit) {
      newErrors.unit = 'Unit is required';
      valid = false;
    }

    if (unit === 'WEEKLY' && selectedDays.length === 0) {
      newErrors.selectedDays = 'Please select at least one day';
      valid = false;
    }

    setErrors(newErrors);

    if (valid) {
      onSave({ repeatEvery, unit, selectedDays });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <SoftBox container spacing={2} sx={{ padding: '15px' }}>
        <SoftTypography variant="h5" color="text" >Custom Recurrence</SoftTypography>
        <SoftBox item xs={12}>
          <SoftTypography variant="caption" color="text" >Repeat every</SoftTypography>
          <SoftInput
            fullWidth
            // label="Repeat every"
            type="number"
            value={repeatEvery}
            onChange={(e) => setRepeatEvery(Number(e.target.value))}
            inputProps={{ min: 1 }}
          />
          {errors.repeatEvery && <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>{errors.repeatEvery}</SoftTypography>}

        </SoftBox>
        <SoftBox item xs={12} mt={2}>
          <CustomSelect
            name={'unit'}
            select
            fullWidth
            label="Unit"
            value={unit}
            options={recurrenceUnits}
            error={errors.unit}
            onChange={(e) => { setUnit(e.target.value); e.target.value === 'days' && setSelectedDays([]) }}
          // option={recurrenceUnits}
          >
          </CustomSelect>
          {errors.unit && <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>{errors.unit}</SoftTypography>}

        </SoftBox>
        {unit === 'WEEKLY' &&
          <Grid item xs={12}>
            <SoftTypography variant="caption" color="text" style={{ marginTop: 8, marginBottom: 4 }}>Select Days</SoftTypography>
            <ToggleButtonGroup
              value={selectedDays}
              onChange={handleDayToggle}
              aria-label="weekdays"
              fullWidth
              sx={{ flexWrap: 'wrap', gap: 1 }}
            >
              {weekDays.map((day) => (
                <ToggleButton
                  key={day}
                  value={day}
                  sx={{
                    flex: '1 1 30%',
                    minWidth: 100,
                    borderRadius: '6px !important',
                    borderLeft: '1px solid #00000030 !important', // ✅ Remove unwanted border-left
                    border: '1px solid #00000030', // ✅ Your custom border
                  }}

                >
                  {day}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
            {errors.selectedDays && <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>{errors.selectedDays}</SoftTypography>}

          </Grid>}
      </SoftBox>

      <DialogActions >
        {/* <Button  variant="outlined" color="primary">
          Cancel
        </Button> */}
        <SoftButton

          variant="outlined"
          color="info"
          onClick={onClose}
        >
          Cancel
        </SoftButton>
        <SoftButton onClick={handleSave} variant="gradient" color="info">
          Done
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
};

export default CustomRecurrenceModal;
